import React, { Suspense } from "react";

import { Switch, Route } from "react-router-dom";

import { HelloWorld } from "../HelloWorld";

export const Application = () => {
    return (
        <React.Fragment>
            <Switch>
                <Route
                    exact
                    path={"/helloWorld"}
                    render={() => (
                        <Suspense>
                            <HelloWorld />
                        </Suspense>
                    )}
                />
            </Switch>
        </React.Fragment>
    );
};
